/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseExamAttemptReportResponseData } from './genericApiResponseExamAttemptReportResponseData';
import type { GenericApiResponseExamAttemptReportResponseMessage } from './genericApiResponseExamAttemptReportResponseMessage';
import type { GenericApiResponseExamAttemptReportResponsePagination } from './genericApiResponseExamAttemptReportResponsePagination';
import type { GenericApiResponseExamAttemptReportResponseError } from './genericApiResponseExamAttemptReportResponseError';

export interface GenericApiResponseExamAttemptReportResponse {
  data?: GenericApiResponseExamAttemptReportResponseData;
  message?: GenericApiResponseExamAttemptReportResponseMessage;
  pagination?: GenericApiResponseExamAttemptReportResponsePagination;
  error?: GenericApiResponseExamAttemptReportResponseError;
  statusCode?: number;
}
